"use client";

import { useEffect } from "react";
import { reportCrash } from "@/lib/client-errors";
import { isConnectionLost, isStaleApp, reloadForNewVersion } from "@/lib/stale-app";
import { brand, palette } from "@/theme/tokens";

/** The last safety net (the whole app's frame failed): plain HTML, no theme, still reported. */
export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    if (isStaleApp(error) && reloadForNewVersion()) return;
    // The connection dropped: not a crash.
    if (isConnectionLost(error)) return;
    reportCrash(error, "root");
  }, [error]);
  return (
    <html lang="en">
      <body style={{ margin: 0, fontFamily: "system-ui, sans-serif", background: palette.light.background.default, color: palette.light.text.primary }}>
        <main style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 16 }}>
          <div style={{ maxWidth: 440, textAlign: "center" }}>
            <h1 style={{ fontSize: 20 }}>{brand.name} hit a problem</h1>
            <p>Nothing is lost: videos being made carry on. Please try again.</p>
            <button onClick={() => reset()} style={{ marginRight: 8, padding: "8px 16px" }}>
              Try again
            </button>
            <button onClick={() => window.location.reload()} style={{ padding: "8px 16px" }}>
              Reload
            </button>
          </div>
        </main>
      </body>
    </html>
  );
}
